import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {DropdownModule, CalendarModule, CheckboxModule} from 'primeng/primeng';
import {CustomPaginationComponent} from './pagination/custom-pagination.component';
import {FilterHeaderComponent} from './filter-header/filter-header.component';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {LoadingSpinnerComponent} from './loading-spinner/loading-spinner.component';
import { CommentComponent } from './comment/comment.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DropdownModule,
    NgbPaginationModule,
    BrowserModule,
    FormsModule,
    CalendarModule,
    CheckboxModule
  ],
  declarations: [
    CustomPaginationComponent,
    FilterHeaderComponent,
    LoadingSpinnerComponent,
    CommentComponent,
    DeleteModalComponent
  ],
    exports: [
        CustomPaginationComponent,
        FilterHeaderComponent,
        LoadingSpinnerComponent,
        CalendarModule,
        CheckboxModule,
        DropdownModule,
        CommentComponent,
        DeleteModalComponent
    ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/core/core.module.ts